import React from "react";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

export default function OfferComparisonTable({ offers = [] }) {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Angebotsvergleich
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Lieferant</TableCell>
            <TableCell>Teil</TableCell>
            <TableCell>Preis (netto)</TableCell>
            <TableCell>Bestand</TableCell>
            <TableCell>Lieferzeit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {offers.map((offer) => (
            <TableRow key={offer.offerId}>
              <TableCell>{offer.supplierName ?? offer.supplierId}</TableCell>
              <TableCell>{offer.partNumber}</TableCell>
              <TableCell>{offer.priceNet}</TableCell>
              <TableCell>{offer.availabilityQuantity}</TableCell>
              <TableCell>{offer.leadTimeDays} Tage</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {offers.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Noch keine Angebote verfügbar.
        </Typography>
      )}
    </Paper>
  );
}
